// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"styles_disclaimer__H5Xmk","img":"styles_img___oazI","fadeInOut":"styles_fadeInOut__CnKrk","loader":"styles_loader__9H0Q0"};